import { createFeature, createReducer, on } from '@ngrx/store';
import { ConsoleActions } from './console.actions';
import { TenantDto, SubscriptionDto } from '@stores/tenants/models/tenant.model';

export interface ConsoleState {
  selectedTenant: TenantDto | null;
  selectedSubscription: SubscriptionDto | null;
}

const initialState: ConsoleState = {
  selectedTenant: null,
  selectedSubscription: null,
};

const reducer = createReducer(
  initialState,
  on(ConsoleActions.setSelectedTenant, (state, { tenant }): ConsoleState => ({
    ...state,
    selectedTenant: tenant,
  })),
  on(ConsoleActions.setSelectedSubscription, (state, { subscription }): ConsoleState => ({
    ...state,
    selectedSubscription: subscription,
  })),
  on(ConsoleActions.clearSelections, (state): ConsoleState => ({
    ...state,
    selectedTenant: null,
    selectedSubscription: null,
  })),
);

export const consoleFeature = createFeature({
  name: 'console',
  reducer,
});
